import { MemberAvatar } from './MemberAvatar'
import { MemberName } from './MemberName'
import { ClubMemberStar } from './ClubMemberStar'
import type { ReactNode } from 'react'

interface Props {
  userId: string | null
  name: string
  nickname?: string | null
  email?: string | null
  avatarExt?: string | null
  avatarUpdatedAt?: string | null
  avatarUrl?: string | null
  size?: 'sm' | 'md' | 'lg'
  primaryColor?: string | null
  isClubMember?: boolean
  /** A line under the name in place of the email, e.g. "Checked in at 17:42 · Monthly". */
  subtitle?: ReactNode
}

export function MemberIdentity({
  userId,
  name,
  nickname,
  email,
  avatarExt,
  avatarUpdatedAt,
  avatarUrl,
  size = 'sm',
  primaryColor,
  isClubMember,
  subtitle,
}: Props) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <MemberAvatar
        userId={userId}
        name={name}
        avatarExt={avatarExt ?? null}
        avatarUpdatedAt={avatarUpdatedAt ?? null}
        avatarUrl={avatarUrl}
        size={size}
        primaryColor={primaryColor}
      />
      <div className="flex min-w-0 flex-col">
        <div className="flex min-w-0 items-center gap-1">
          <MemberName
            name={name}
            nickname={nickname}
            className="min-w-0 truncate text-sm font-semibold"
          />
          {isClubMember && <ClubMemberStar />}
        </div>
        {subtitle ? (
          <p className="truncate text-xs text-foreground/55">{subtitle}</p>
        ) : (
          email && <p className="truncate text-xs text-foreground/50">{email}</p>
        )}
      </div>
    </div>
  )
}
